import {
	BarController,
	BarElement,
	CategoryScale,
	Chart as ChartJS,
	Filler,
	Legend,
	LinearScale,
	LineController,
	LineElement,
	PointElement,
	Title,
	Tooltip,
	ScatterController,
} from "chart.js";

export default function () {
	ChartJS.register(
		CategoryScale,
		LinearScale,
		BarElement,
		LineElement,
		Title,
		Tooltip,
		Legend,
		PointElement,
		Filler,
		LineController,
		BarController,
		ScatterController
	);
}
